export default "__VITE_ASSET__BAsFqN_C__"